export default __webpack_public_path__ + "static/lsa-screens-1-mobile-1ab01b128f7f9fa5ab1db38028b9bbe8.jpg";